const VIETNAM_PROVINCES = [
  {
    value: 'Hanoi',
    label: '河内市 (Ha Noi)',
    wards: [
      { value: 'Ba Dinh', label: 'Ba Đình（巴亭区）' },
      { value: 'Hoan Kiem', label: 'Hoàn Kiếm（还剑区）' },
      { value: 'Cau Giay', label: 'Cầu Giấy（纸桥区）' },
      { value: 'Dong Da', label: 'Đống Đa（铜多区）' },
      { value: 'Hoang Mai', label: 'Hoàng Mai（黄梅区）' },
      { value: 'Thanh Xuan', label: 'Thanh Xuân（青春区）' },
    ],
  },
  {
    value: 'Ho Chi Minh City',
    label: '胡志明市 (Ho Chi Minh City)',
    wards: [
      { value: 'District 1', label: '第一区' },
      { value: 'District 3', label: '第三区' },
      { value: 'District 5', label: '第五区' },
      { value: 'District 7', label: '第七区' },
      { value: 'Thu Duc City', label: '守德市' },
      { value: 'Go Vap', label: '戈宛县' },
    ],
  },
  {
    value: 'Da Nang',
    label: '岘港市 (Da Nang)',
    wards: [
      { value: 'Hai Chau', label: 'Hải Châu（海洲区）' },
      { value: 'Thanh Khe', label: 'Thanh Khê（清溪区）' },
      { value: 'Lien Chieu', label: 'Liên Chiểu（莲沼区）' },
      { value: 'Ngu Hanh Son', label: 'Ngũ Hành Sơn（五行山区）' },
      { value: 'Son Tra', label: 'Sơn Trà（山茶区）' },
    ],
  },
  {
    value: 'Hai Phong',
    label: '海防市 (Hai Phong)',
    wards: [
      { value: 'Hong Bang', label: 'Hồng Bàng（鸿庞区）' },
      { value: 'Le Chan', label: 'Lê Chân（黎真区）' },
      { value: 'Ngo Quyen', label: 'Ngô Quyền（吴权区）' },
      { value: 'Kien An', label: 'Kiến An（建安区）' },
      { value: 'Do Son', label: 'Đồ Sơn（渎山区）' },
    ],
  },
  {
    value: 'Can Tho',
    label: '芹苴市 (Can Tho)',
    wards: [
      { value: 'Ninh Kieu', label: '宁桥区' },
      { value: 'Binh Thuy', label: '平水区' },
      { value: 'Cai Rang', label: '改郎区' },
      { value: 'O Mon', label: '乌门区' },
      { value: 'Thot Not', label: ' Thốt Nốt（托诺）' },
    ],
  },
  {
    value: 'An Giang',
    label: '安江省 (An Giang)',
    wards: [
      { value: 'Long Xuyen', label: '龙江市' },
      { value: 'Chau Doc', label: '朱笃市' },
      { value: 'Tan Chau', label: '新州镇' },
      { value: 'Chau Phu', label: '朱富县' },
      { value: 'Chau Thanh', label: '洲城县' },
    ],
  },
  {
    value: 'Ba Ria - Vung Tau',
    label: '巴地-头顿省',
    wards: [
      { value: 'Vung Tau City', label: '头顿市' },
      { value: 'Ba Ria City', label: '巴地市' },
      { value: 'Long Dien', label: '隆田县' },
      { value: 'Dat Do', label: '达都县' },
      { value: 'Phu My', label: '富美镇' },
    ],
  },
  {
    value: 'Bac Giang',
    label: '北江省',
    wards: [
      { value: 'Bac Giang City', label: '北江市' },
      { value: 'Viet Yen', label: '越安县' },
      { value: 'Lang Giang', label: '朗江县' },
      { value: 'Luc Ngan', label: '禄媪县' },
      { value: 'Son Dong', label: '山洞县' },
    ],
  },
  {
    value: 'Bac Kan',
    label: '北𣴓省 (Bắc Kạn)',
    wards: [
      { value: 'Bac Kan City', label: '北𣴓市' },
      { value: 'Cho Don', label: '𠬠頓县' },
      { value: 'Cho Moi', label: '𠬠枚县' },
      { value: 'Na Ri', label: '那利县' },
      { value: 'Ba Be', label: '巴贝县' },
    ],
  },
  {
    value: 'Bac Lieu',
    label: '薄遼省 (Bạc Liêu)',
    wards: [
      { value: 'Bac Lieu City', label: '薄遼市' },
      { value: 'Gia Rai', label: '嘉莱镇' },
      { value: 'Hong Dan', label: '鸿丹县' },
      { value: 'Phuoc Long', label: '福隆县' },
      { value: 'Dong Hai', label: '东海县' },
    ],
  },
  {
    value: 'Bac Ninh',
    label: '北宁省',
    wards: [
      { value: 'Bac Ninh City', label: '北宁市' },
      { value: 'Tu Son', label: '慈山市' },
      { value: 'Thuan Thanh', label: '顺成县' },
      { value: 'Tien Du', label: '先都县' },
      { value: 'Yen Phong', label: '安丰县' },
    ],
  },
  {
    value: 'Ben Tre',
    label: '槟椥省',
    wards: [
      { value: 'Ben Tre City', label: '槟椥市' },
      { value: 'Chau Thanh District', label: '洲城县' },
      { value: 'Mo Cay Bac', label: '北谋逮县' },
      { value: 'Mo Cay Nam', label: '南谋逮县' },
      { value: 'Ba Tri', label: '巴知县' },
    ],
  },
  {
    value: 'Binh Duong',
    label: '平阳省',
    wards: [
      { value: 'Thu Dau Mot', label: '土油一市' },
      { value: 'Di An', label: '易安市' },
      { value: 'Thuan An', label: '顺安市' },
      { value: 'Tan Uyen', label: '新渊市' },
      { value: 'Ben Cat', label: '边葛市镇' },
    ],
  },
  {
    value: 'Binh Dinh',
    label: '平定省',
    wards: [
      { value: 'Quy Nhon', label: '归仁市' },
      { value: 'An Nhon', label: '安仁镇' },
      { value: 'Hoai Nhon', label: '怀仁市' },
      { value: 'Tay Son', label: '西山市' },
      { value: 'Phu Cat', label: '富吉县' },
    ],
  },
  {
    value: 'Binh Phuoc',
    label: '平福省',
    wards: [
      { value: 'Dong Xoai', label: '同帅市' },
      { value: 'Phuoc Long Town', label: '福隆镇' },
      { value: 'Binh Long', label: '平隆镇' },
      { value: 'Chon Thanh', label: '真诚县' },
      { value: 'Bu Dang', label: '布当县' },
    ],
  },
  {
    value: 'Binh Thuan',
    label: '平顺省',
    wards: [
      { value: 'Phan Thiet', label: '潘切市' },
      { value: 'La Gi', label: '拉吉镇' },
      { value: 'Tuy Phong', label: '锦风县' },
      { value: 'Bac Binh', label: '北平县' },
      { value: 'Ham Thuan Bac', label: '咸顺北县' },
    ],
  },
  {
    value: 'Ca Mau',
    label: '金瓯省 (Cà Mau)',
    wards: [
      { value: 'Ca Mau City', label: '金瓯市' },
      { value: 'Nam Can', label: '南坚县' },
      { value: 'Ngoc Hien', label: '玉显县' },
      { value: 'Cai Nuoc', label: '改玉县' },
      { value: 'Tran Van Thoi', label: '陈文明县' },
    ],
  },
  {
    value: 'Cao Bang',
    label: '高平省',
    wards: [
      { value: 'Cao Bang City', label: '高平市' },
      { value: 'Hoa An', label: '和安县' },
      { value: 'Quang Hoa', label: '广和县' },
      { value: 'Trung Khanh', label: '中庆县' },
      { value: 'Ha Quang', label: '河广县' },
    ],
  },
  {
    value: 'Dak Lak',
    label: '得乐省 (Đắk Lắk)',
    wards: [
      { value: 'Buon Ma Thuot', label: '邦美蜀市' },
      { value: 'Buon Ho', label: '邦湖镇' },
      { value: 'Krong Pac', label: '空拍县' },
      { value: 'Ea Kar', label: '埃卡县' },
      { value: 'Cu Mgar', label: '旧芒俄县' },
    ],
  },
  {
    value: 'Dak Nong',
    label: '得农省',
    wards: [
      { value: 'Gia Nghia', label: '嘉义市' },
      { value: 'Dak Mil', label: '得迷县' },
      { value: 'Dak Song', label: '得生县' },
      { value: 'Krong No', label: '孔奴县' },
      { value: 'Cu Jut', label: '固渚县' },
    ],
  },
  {
    value: 'Dien Bien',
    label: '奠边省 (Điện Biên)',
    wards: [
      { value: 'Dien Bien Phu', label: '奠边府市' },
      { value: 'Muong Lay', label: '芒莱镇' },
      { value: 'Muong Nhe', label: '芒聂县' },
      { value: 'Tua Chua', label: '嘐州县' },
      { value: 'Tuan Giao', label: '敦教县' },
    ],
  },
  {
    value: 'Dong Nai',
    label: '同奈省',
    wards: [
      { value: 'Bien Hoa', label: '边和市' },
      { value: 'Long Khanh', label: '隆慶市' },
      { value: 'Nhon Trach', label: '仁泽县' },
      { value: 'Long Thanh', label: '隆城县' },
      { value: 'Trang Bom', label: '彰边县' },
    ],
  },
  {
    value: 'Dong Thap',
    label: '同塔省',
    wards: [
      { value: 'Cao Lanh', label: '高领市' },
      { value: 'Sa Dec', label: '沙笛市' },
      { value: 'Hong Ngu', label: '鸿渔镇' },
      { value: 'Lai Vung', label: '来荣县' },
      { value: 'Lap Vo', label: '立和县' },
    ],
  },
  {
    value: 'Gia Lai',
    label: '嘉莱省',
    wards: [
      { value: 'Pleiku', label: '波来古市' },
      { value: 'An Khe', label: '安溪镇' },
      { value: 'Ayun Pa', label: '阿云巴镇' },
      { value: 'Chu Prong', label: '朱蓬县' },
      { value: 'Chu Se', label: '朱瑟县' },
    ],
  },
  {
    value: 'Ha Giang',
    label: '河江省',
    wards: [
      { value: 'Ha Giang City', label: '河江市' },
      { value: 'Dong Van', label: '同文县' },
      { value: 'Meo Vac', label: '苗旺县' },
      { value: 'Quan Ba', label: '官坝县' },
      { value: 'Yen Minh', label: '安明县' },
    ],
  },
  {
    value: 'Ha Nam',
    label: '河南省',
    wards: [
      { value: 'Phu Ly', label: '府里市' },
      { value: 'Duy Tien', label: '维先市' },
      { value: 'Binh Luc', label: '平陆县' },
      { value: 'Kim Bang', label: '金榜县' },
      { value: 'Thanh Liem', label: '青廉县' },
    ],
  },
  {
    value: 'Ha Tinh',
    label: '河静省',
    wards: [
      { value: 'Ha Tinh City', label: '河静市' },
      { value: 'Hong Linh', label: '红玲镇' },
      { value: 'Ky Anh', label: '奇英镇' },
      { value: 'Cam Xuyen', label: '锦川县' },
      { value: 'Thach Ha', label: '石河县' },
    ],
  },
  {
    value: 'Hai Duong',
    label: '海阳省',
    wards: [
      { value: 'Hai Duong City', label: '海阳市' },
      { value: 'Chi Linh', label: '枝陵市' },
      { value: 'Cam Giang', label: '锦江县' },
      { value: 'Tu Ky', label: '四岐县' },
      { value: 'Binh Giang', label: '平江县' },
    ],
  },
  {
    value: 'Hau Giang',
    label: '后江省',
    wards: [
      { value: 'Vi Thanh', label: '维清市' },
      { value: 'Nga Bay', label: '俄北市' },
      { value: 'Long My', label: '龙美镇' },
      { value: 'Phung Hiep', label: '凤协县' },
      { value: 'Chau Thanh', label: '洲城县' },
    ],
  },
  {
    value: 'Hoa Binh',
    label: '和平省 (Hòa Bình)',
    wards: [
      { value: 'Hoa Binh City', label: '和平市' },
      { value: 'Luong Son', label: '良山县' },
      { value: 'Kim Boi', label: '金杯县' },
      { value: 'Cao Phong', label: '高峰县' },
      { value: 'Mai Chau', label: '麦州县' },
    ],
  },
  {
    value: 'Hung Yen',
    label: '兴安省',
    wards: [
      { value: 'Hung Yen City', label: '兴安市' },
      { value: 'My Hao', label: '美豪镇' },
      { value: 'Van Lam', label: '文林县' },
      { value: 'Khoai Chau', label: '槐洲县' },
      { value: 'Tien Lu', label: '进禄县' },
    ],
  },
  {
    value: 'Khanh Hoa',
    label: '庆和省',
    wards: [
      { value: 'Nha Trang', label: '芽庄市' },
      { value: 'Cam Ranh', label: '金兰市' },
      { value: 'Ninh Hoa', label: '宁和市' },
      { value: 'Van Ninh', label: '万宁县' },
      { value: 'Dien Khanh', label: '延庆县' },
    ],
  },
  {
    value: 'Kien Giang',
    label: '坚江省',
    wards: [
      { value: 'Rach Gia', label: '𦉙耶市' },
      { value: 'Ha Tien', label: '河仙市' },
      { value: 'Phu Quoc', label: '富国岛' },
      { value: 'Kien Luong', label: '坚良县' },
      { value: 'Chau Thanh', label: '洲城县' },
    ],
  },
  {
    value: 'Kon Tum',
    label: '崑嵩省 (Kon Tum)',
    wards: [
      { value: 'Kon Tum City', label: '崑嵩市' },
      { value: 'Ngoc Hoi', label: '玉会县' },
      { value: 'Sa Thay', label: '沙渋县' },
      { value: 'Dak To', label: '得多县' },
      { value: 'Kon Plong', label: '崑龙县' },
    ],
  },
  {
    value: 'Lai Chau',
    label: '莱州省',
    wards: [
      { value: 'Lai Chau City', label: '莱州市' },
      { value: 'Tam Duong', label: '三阳县' },
      { value: 'Phong Tho', label: '风土县' },
      { value: 'Muong Te', label: '芒笛县' },
      { value: 'Sin Ho', label: '薪和县' },
    ],
  },
  {
    value: 'Lam Dong',
    label: '林同省',
    wards: [
      { value: 'Da Lat', label: '大叻市' },
      { value: 'Bao Loc', label: '保禄市' },
      { value: 'Lac Duong', label: '乐阳县' },
      { value: 'Duc Trong', label: '禄中县' },
      { value: 'Lam Ha', label: '林河县' },
    ],
  },
  {
    value: 'Lang Son',
    label: '谅山省',
    wards: [
      { value: 'Lang Son City', label: '谅山市' },
      { value: 'Cao Loc', label: '高禄县' },
      { value: 'Loc Binh', label: '禄平县' },
      { value: 'Chi Lang', label: '枝良县' },
      { value: 'Huu Lung', label: '友陵县' },
    ],
  },
  {
    value: 'Lao Cai',
    label: '老街省',
    wards: [
      { value: 'Lao Cai City', label: '老街市' },
      { value: 'Sa Pa', label: '沙垻镇' },
      { value: 'Bao Thang', label: '保胜县' },
      { value: 'Bat Xat', label: '拔辖县' },
      { value: 'Bao Yen', label: '保延县' },
    ],
  },
  {
    value: 'Long An',
    label: '隆安省',
    wards: [
      { value: 'Tan An', label: '新安市' },
      { value: 'Kien Tuong', label: '坚祥镇' },
      { value: 'Ben Luc', label: '边沥县' },
      { value: 'Duc Hoa', label: '德化县' },
      { value: 'Can Duoc', label: '芹若县' },
    ],
  },
  {
    value: 'Nam Dinh',
    label: '南定省',
    wards: [
      { value: 'Nam Dinh City', label: '南定市' },
      { value: 'My Loc', label: '美禄县' },
      { value: 'Truc Ninh', label: '竹宁县' },
      { value: 'Giao Thuy', label: '交推县' },
      { value: 'Hai Hau', label: '海后县' },
    ],
  },
  {
    value: 'Nghe An',
    label: '乂安省',
    wards: [
      { value: 'Vinh City', label: '荣市' },
      { value: 'Cua Lo', label: '巨渃镇' },
      { value: 'Thai Hoa', label: '泰和镇' },
      { value: 'Hoang Mai', label: '黄梅镇' },
      { value: 'Dien Chau', label: '演州县' },
    ],
  },
  {
    value: 'Ninh Binh',
    label: '宁平省',
    wards: [
      { value: 'Ninh Binh City', label: '宁平市' },
      { value: 'Tam Diep', label: '三挟市' },
      { value: 'Hoa Lu', label: '华闾县' },
      { value: 'Gia Vien', label: '嘉原县' },
      { value: 'Yen Mo', label: '安模县' },
    ],
  },
  {
    value: 'Ninh Thuan',
    label: '宁顺省',
    wards: [
      { value: 'Phan Rang - Thap Cham', label: '潘朗-塔占市' },
      { value: 'Ninh Hai', label: '宁海县' },
      { value: 'Ninh Phuoc', label: '宁福县' },
      { value: 'Thuan Bac', label: '顺北县' },
      { value: 'Bac Ai', label: '北艾县' },
    ],
  },
  {
    value: 'Phu Tho',
    label: '富寿省',
    wards: [
      { value: 'Viet Tri', label: '越池市' },
      { value: 'Phu Tho Town', label: '富寿镇' },
      { value: 'Lam Thao', label: '临洮县' },
      { value: 'Thanh Son', label: '清山县' },
      { value: 'Thanh Ba', label: '清坝县' },
    ],
  },
  {
    value: 'Phu Yen',
    label: '富安省',
    wards: [
      { value: 'Tuy Hoa', label: '绥和市' },
      { value: 'Song Cau', label: '宋油镇' },
      { value: 'Dong Hoa', label: '东和镇' },
      { value: 'Tay Hoa', label: '西和县' },
      { value: 'Son Hoa', label: '山和县' },
    ],
  },
  {
    value: 'Quang Binh',
    label: '广平省',
    wards: [
      { value: 'Dong Hoi', label: '洞海市' },
      { value: 'Ba Don Town', label: '巴顿镇' },
      { value: 'Quang Trach', label: '广泽县' },
      { value: 'Bo Trach', label: '布泽县' },
      { value: 'Le Thuy', label: '礼推县' },
    ],
  },
  {
    value: 'Quang Nam',
    label: '广南省',
    wards: [
      { value: 'Tam Ky', label: '心圻市' },
      { value: 'Hoi An', label: '会安市' },
      { value: 'Dien Ban', label: '仙盘镇' },
      { value: 'Nui Thanh', label: '女城县' },
      { value: 'Thang Binh', label: '升平县' },
    ],
  },
  {
    value: 'Quang Ngai',
    label: '广义省',
    wards: [
      { value: 'Quang Ngai City', label: '广义市' },
      { value: 'Duc Pho', label: '德婆镇' },
      { value: 'Binh Son', label: '平山县' },
      { value: 'Tu Nghia', label: '慈义县' },
      { value: 'Son Tinh', label: '山青县' },
    ],
  },
  {
    value: 'Quang Ninh',
    label: '广宁省',
    wards: [
      { value: 'Ha Long', label: '下龙市' },
      { value: 'Mong Cai', label: '芒街市' },
      { value: 'Cam Pha', label: '锦普市' },
      { value: 'Uong Bi', label: '翁比市' },
      { value: 'Quang Yen', label: '广安市' },
    ],
  },
  {
    value: 'Quang Tri',
    label: '广治省',
    wards: [
      { value: 'Dong Ha', label: '洞哈市' },
      { value: 'Quang Tri Town', label: '广治镇' },
      { value: 'Lao Bao', label: '老保镇' },
      { value: 'Cam Lo', label: '锦禄县' },
      { value: 'Gio Linh', label: '蕉灵县' },
    ],
  },
  {
    value: 'Soc Trang',
    label: '朔庄省',
    wards: [
      { value: 'Soc Trang City', label: '朔庄市' },
      { value: 'Nga Nam', label: '俄南县' },
      { value: 'Vinh Chau', label: '荣周镇' },
      { value: 'My Xuyen', label: '美川县' },
      { value: 'Chau Thanh', label: '洲城县' },
    ],
  },
  {
    value: 'Son La',
    label: '山罗省',
    wards: [
      { value: 'Son La City', label: '山罗市' },
      { value: 'Moc Chau', label: '木州县' },
      { value: 'Mai Son', label: '梅山县' },
      { value: 'Quynh Nhai', label: '瓊崖县' },
      { value: 'Thuan Chau', label: '顺州县' },
    ],
  },
  {
    value: 'Tay Ninh',
    label: '西宁省',
    wards: [
      { value: 'Tay Ninh City', label: '西宁市' },
      { value: 'Hoa Thanh', label: '和城县' },
      { value: 'Trang Bang', label: '彰邦镇' },
      { value: 'Go Dau', label: '𢄂油县' },
      { value: 'Ben Cau', label: '边逮县' },
    ],
  },
  {
    value: 'Thai Binh',
    label: '太平省',
    wards: [
      { value: 'Thai Binh City', label: '太平市' },
      { value: 'Dong Hung', label: '东兴县' },
      { value: 'Tien Hai', label: '仙海县' },
      { value: 'Quynh Phu', label: '瓊浦县' },
      { value: 'Hung Ha', label: '兴河县' },
    ],
  },
  {
    value: 'Thai Nguyen',
    label: '太原省',
    wards: [
      { value: 'Thai Nguyen City', label: '太原市' },
      { value: 'Song Cong', label: '颂公市' },
      { value: 'Pho Yen', label: '富安市' },
      { value: 'Dai Tu', label: '大慈县' },
      { value: 'Phu Binh', label: '富平县' },
    ],
  },
  {
    value: 'Thanh Hoa',
    label: '清化省',
    wards: [
      { value: 'Thanh Hoa City', label: '清化市' },
      { value: 'Sam Son', label: '山山市' },
      { value: 'Bim Son', label: '锦山市' },
      { value: 'Nghi Son', label: '宜山市' },
      { value: 'Tho Xuan', label: '寿春县' },
    ],
  },
  {
    value: 'Thua Thien Hue',
    label: '承天顺化省',
    wards: [
      { value: 'Hue City', label: '顺化市' },
      { value: 'Huong Thuy', label: '香水市' },
      { value: 'Huong Tra', label: '香茶市' },
      { value: 'Phong Dien', label: '丰田县' },
      { value: 'Phu Vang', label: '富荣县' },
    ],
  },
  {
    value: 'Tien Giang',
    label: '前江省',
    wards: [
      { value: 'My Tho', label: '美拖市' },
      { value: 'Go Cong', label: '哥公镇' },
      { value: 'Cai Lay', label: '改莱市' },
      { value: 'Cai Be', label: '改弼县' },
      { value: 'Chau Thanh', label: '洲城县' },
    ],
  },
  {
    value: 'Tra Vinh',
    label: '茶荣省',
    wards: [
      { value: 'Tra Vinh City', label: '茶荣市' },
      { value: 'Duyen Hai', label: '缘海镇' },
      { value: 'Cang Long', label: '冈隆县' },
      { value: 'Cau Ngang', label: '纠梗县' },
      { value: 'Tieu Can', label: '小坚县' },
    ],
  },
  {
    value: 'Tuyen Quang',
    label: '宣光省',
    wards: [
      { value: 'Tuyen Quang City', label: '宣光市' },
      { value: 'Son Duong', label: '山阳县' },
      { value: 'Yen Son', label: '安山县' },
      { value: 'Ham Yen', label: '含延县' },
      { value: 'Chiem Hoa', label: '沾化县' },
    ],
  },
  {
    value: 'Vinh Long',
    label: '永隆省',
    wards: [
      { value: 'Vinh Long City', label: '永隆市' },
      { value: 'Binh Minh', label: '平明市' },
      { value: 'Long Ho', label: '龙湖县' },
      { value: 'Tam Binh', label: '三平县' },
      { value: 'Tra On', label: '茶温县' },
    ],
  },
  {
    value: 'Vinh Phuc',
    label: '永福省',
    wards: [
      { value: 'Vinh Yen', label: '永安市' },
      { value: 'Phuc Yen', label: '福安市' },
      { value: 'Binh Xuyen', label: '平川县' },
      { value: 'Tam Duong', label: '三阳县' },
      { value: 'Lap Thach', label: '立石县' },
    ],
  },
  {
    value: 'Yen Bai',
    label: '安沛省',
    wards: [
      { value: 'Yen Bai City', label: '安沛市' },
      { value: 'Nghia Lo', label: '宜路镇' },
      { value: 'Van Yen', label: '文安县' },
      { value: 'Luc Yen', label: '禄安县' },
      { value: 'Tran Yen', label: '振安县' },
    ],
  },
];

export default VIETNAM_PROVINCES;
